import React from 'react'

const YouTubeIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="16"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#000"
      d="M21.193 3.84s-.203-1.434-.829-2.064C19.572.948 18.686.944 18.28.895 15.371.684 11.004.684 11.004.684h-.008s-4.367 0-7.276.21c-.406.05-1.292.054-2.084.882C1.01 2.406.811 3.84.811 3.84s-.21 1.686-.21 3.368v1.576c0 1.682.206 3.368.206 3.368s.203 1.434.825 2.064c.792.829 1.832.8 2.295.89 1.666.158 7.073.207 7.073.207s4.371-.008 7.28-.216c.406-.048 1.292-.053 2.084-.881.626-.63.829-2.064.829-2.064s.207-1.682.207-3.368V7.208c0-1.682-.207-3.368-.207-3.368zM8.85 10.698V4.852l5.618 2.933-5.618 2.913z"
    ></path>
  </svg>
)

export default YouTubeIcon
